<template>
  <div class="pageContainer">
    <div class="contentContainer grow" style="margin-bottom: 16px">
      <div class="whitebox flex-column align-items-center p-10">
        <IllustrationsSpinnerCircle />
        <p class="has-text-size-20 bold my-3 is-text-centered">
          {{ $t("bnpl:limit.scoring.waiting_for_result") }}
        </p>
      </div>
    </div>
    <div class="actionArea">
      <button
        class="linkButton linkButtonSuccess justify-self-start-desktop leftAction"
        @click="previousStep"
      >
        <font-awesome-icon :icon="['fas', 'arrow-left']" />{{
          $t("bnpl:cancel")
        }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useLimitStore } from "~~/stores/limit";

const limitStore = useLimitStore();

const pollingInterval = ref(null);

onMounted(() => {
  limitStore.scoringEvaluate();
  pollingInterval.value = setInterval(() => {
    limitStore.fetchMyLastLimit();
  }, 1000);
});

onBeforeUnmount(() => {
  clearInterval(pollingInterval.value);
});

function previousStep() {
  limitStore.previousPosition();
}

async function getStatus() {
  window.location.reload();
}
</script>

<style scoped lang="scss">
.is-text-centered {
  text-align: center;
}
@media only screen and (max-width: 792px) {
  .p-10 {
    padding: 50px
  }
}
</style>
